import { Flex, Tooltip, Typography } from "antd";
import { v4 as uuid } from "uuid";

import { EditQuoteExpTimeButton, EditWalletButton, AddWalletButton } from "components";
import {
  COMPANY_TYPES,
  CompanyEntity,
  ExpandNetworkType,
  ItemInfoType,
  NETWORK_TEXT,
  NETWORK_TEXT_WITHOUT_STANDARD,
  USER_ROLES,
  UserListEntity,
  WalletEntity,
} from "interfaces";
import { TxButton, RoleTag } from "ui";
import {
  convertFromISOHourMinuteDuration,
  dateFormat,
  EXPLORER_LINK_TYPE,
  getBlockchainExplorerLink,
  getPhone,
} from "utils";
import { UserStore } from "stores/UserStore";

export const getInfoUserColumns = (data: UserListEntity & { scope: string[] }): Array<ItemInfoType> => {
  const { email, phone, statusDate, attorney, attorneyDate, attorneyExpirationDate, scope, position } = data;

  return [
    {
      label: "Номер телефона",
      text: getPhone(phone),
    },
    {
      label: "E-mail",
      text: email,
    },
    position && {
      label: "Должность",
      text: position,
    },
    // attorney && {
    //   label: "Номер доверенности",
    //   text: attorney,
    // },
    // attorneyDate &&
    //   attorneyExpirationDate && {
    //     label: "Срок действия доверенности",
    //     text: `${dateFormat(attorneyDate)} - ${dateFormat(attorneyExpirationDate)}`,
    //   },
    {
      label: "Дата смены статуса",
      text: dateFormat(statusDate, true),
    },
    {
      label: "Роли",
      text: (
        <Flex gap="small" wrap className="margin-top-xxs">
          {scope.map((role) => (
            <RoleTag key={role} className="bg-white">
              {USER_ROLES.texts[role as keyof typeof USER_ROLES.texts]}
            </RoleTag>
          ))}
        </Flex>
      ),
    },
  ].filter((c) => !!c);
};

export const getInfoUserLPColumns = (
  data: CompanyEntity,
  providerWallets: WalletEntity[],
  user: UserStore
): Array<ItemInfoType> => {
  const { isSeniorLP } = user.roles;

  const quoteDuration = convertFromISOHourMinuteDuration(
    // @ts-ignore
    data.defaultQuoteExpDuration ?? ""
  );
  const indefiniteExpiration = quoteDuration[0] === 0 && quoteDuration[1] === 0;

  const walletsByNetwork: Record<ExpandNetworkType, WalletEntity[]> = {} as Record<ExpandNetworkType, WalletEntity[]>;

  Object.keys(NETWORK_TEXT).forEach((network) => {
    walletsByNetwork[network as ExpandNetworkType] = [];
  });

  providerWallets.forEach((wallet) => {
    if (walletsByNetwork[wallet.network]) {
      walletsByNetwork[wallet.network].push(wallet);
    }
  });

  const walletColumns = Object.entries(NETWORK_TEXT_WITHOUT_STANDARD).map(([network, networkName]) => ({
    label: <span id="profile-blockchain-addresses">Адрес в сети {networkName} по умолчанию</span>,
    text:
      walletsByNetwork[network as ExpandNetworkType].length > 0
        ? walletsByNetwork[network as ExpandNetworkType].map((wallet, i) => (
            <Flex gap="small" key={uuid()} align="center">
              <TxButton
                isWalletAddress
                text={wallet.address}
                showCopyBtn
                href={getBlockchainExplorerLink(wallet.network, wallet.address, EXPLORER_LINK_TYPE.address)}
                infoBlock
              />
              {/* {isSeniorLP && <EditWalletButton wallet={wallet} />} */}
            </Flex>
          ))
        : null,
    width: 8,
  }));

  return [
    {
      id: "profile-quotes-dates",
      label: "Срок действия котировок по умолчанию",
      text: (
        <Flex gap="small" align="center">
          {data.defaultQuoteExpDuration ? (
            indefiniteExpiration ? (
              <Tooltip title="Котировка не ограничена во времени">
                <Typography.Text className="text-middle">Бессрочно</Typography.Text>
              </Tooltip>
            ) : (
              <Typography.Text className="text-middle">
                {quoteDuration[0]} ч {quoteDuration[1]} мин
              </Typography.Text>
            )
          ) : (
            "Не задано"
          )}
          {isSeniorLP && (
            <EditQuoteExpTimeButton
              // @ts-ignore
              defaultQuoteExpTime={data.defaultQuoteExpDuration ?? ""}
            />
          )}
        </Flex>
      ),
      width: 8,
    },
  ].filter((c) => !!c);
};

export const getInfoCompanyColumns = (data: CompanyEntity, user?: UserStore): Array<ItemInfoType> => {
  const {
    companyName,
    companyRegistrationNumber,
    inn,
    createdAt,
    kpp,
    type,

    surname,
    name,
    patronymic,
    birthDate,
  } = data;

  const { isOperator } = user?.roles ?? {};

  const registrationNumberTitle = type === COMPANY_TYPES.COMPANY ? "ОГРН" : "ОГРНИП";

  return [
    companyName && {
      label: "Наименование компании",
      text: companyName,
      width: 24,
    },
    surname && {
      label: "Фамилия",
      text: surname,
      width: 6,
    },
    name && {
      label: "Имя",
      text: name,
      width: 6,
    },
    patronymic && {
      label: "Отчество",
      text: patronymic,
      width: 6,
    },

    {
      label: registrationNumberTitle,
      text: companyRegistrationNumber,
      width: 6,
    },
    {
      label: "ИНН",
      text: inn,
      width: 6,
    },
    type === COMPANY_TYPES.COMPANY && {
      label: "КПП",
      text: kpp,
      width: 6,
    },
    createdAt && {
      label: "Дата регистрации",
      text: dateFormat(createdAt),
      width: 6,
    },
    data.phone && {
      label: "Номер телефона",
      text: getPhone(data.phone),
      width: 6,
    },
    data.email && {
      label: "Email",
      text: data.email,
      width: 6,
    },
  ].filter((c) => !!c);
};
